<template>
  <div class="wrapper">
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editRole"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteRole"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editRole: function () {
      this.params.context.componentParent.editRole(this.params.data);
    },
    deleteRole: function () {
      this.params.context.componentParent.deleteRole(this.params.data);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
